export enum ERRORS {
    FORBIDDEN_ERROR = 'ForbiddenError',
    NOT_FOUND_ERROR = 'NotFoundError',
    VALIDATE_ERROR = 'ValidateError',
    BAD_REQUEST_ERROR = 'BadRequestError',
}
